module.exports = __webpack_public_path__ + "static/media/YB_LOGO.68ac3a23.jpg";